<!-- custom-file-input.component.html -->
<div class="custom-file-input">
  <input
    type="file"
    #fileInput
    style="display: none"
    (change)="onFileChange($event)"
    [accept]="accept"
    [required]="required"
  />
  <button mat-button (click)="fileInput.click()">Select File</button>
  <span *ngFor="let file of selectedFiles">
    {{ file.name }}
  </span>
</div>
